export const MemberOfTheMonthIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>M</h5>;
};
